/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateParameterNameRequestDto
 */
export interface UpdateParameterNameRequestDto {
    /**
     * Unique code for the parameter name
     * @type {string}
     * @memberof UpdateParameterNameRequestDto
     */
    code?: string;
    /**
     * Name of the parameter
     * @type {string}
     * @memberof UpdateParameterNameRequestDto
     */
    name?: string;
    /**
     * Unit of measurement for the parameter
     * @type {string}
     * @memberof UpdateParameterNameRequestDto
     */
    unit?: string;
}

/**
 * Check if a given object implements the UpdateParameterNameRequestDto interface.
 */
export function instanceOfUpdateParameterNameRequestDto(value: object): value is UpdateParameterNameRequestDto {
    return true;
}

export function UpdateParameterNameRequestDtoFromJSON(json: any): UpdateParameterNameRequestDto {
    return UpdateParameterNameRequestDtoFromJSONTyped(json, false);
}

export function UpdateParameterNameRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateParameterNameRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'unit': json['unit'] == null ? undefined : json['unit'],
    };
}

export function UpdateParameterNameRequestDtoToJSON(json: any): UpdateParameterNameRequestDto {
    return UpdateParameterNameRequestDtoToJSONTyped(json, false);
}

export function UpdateParameterNameRequestDtoToJSONTyped(value?: UpdateParameterNameRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'unit': value['unit'],
    };
}

